<template>
    <b-form>
        <b-row>
            <b-col>
                <b-form-group
                    label="Date de début"
                    required="true">
                    <vue-monthly-picker
                        id="input-date"
                        dateFormat="MM/YYYY"
                        :monthLabels="monthLabels"
                        v-model="date">
                    </vue-monthly-picker>
                    <div class="typo-warning" v-if="isBeforeDate()">
                      la date de fin doit être postérieure à la date de début
                    </div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                    label="Date de fin">
                    <vue-monthly-picker
                        id="input-date-fin"
                        dateFormat="MM/YYYY"
                        :monthLabels="monthLabels"
                        v-model="dateFin">
                    </vue-monthly-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="pt-2" align-h="center">
            <b-button v-if="date && !isBeforeDate()" type="button" variant="primary" @click="exporter">
                Valider l'export
            </b-button>
        </b-row>
    </b-form>
</template>

<script>
import {mois} from "@/constants/enums";
import VueMonthlyPicker from "vue-monthly-picker";
import ReportingStore from "@/stores/ReportingStore";
import FileUtil from "@/utils/fileUtil";
import AlertStore from "@/stores/AlertStore";
import {momentToDate} from "@/utils/dateUtil";
import moment from "moment";
import ExportReportingMensuelDto from "@/dtos/ExportReportingMensuelDto";

export default {
  name: "ReportingChoixDateDispenses",
  components: {
    VueMonthlyPicker
  },

  data() {
    return {
      monthLabels: mois,
      date: null,
      dateFin: null
    }
  },
  methods: {
    exporter() {
      if(this.dateFin==null) {
        this.dateFin = moment(Date.now());
      }
      if (this.date && this.dateFin) {
        const reporting = this.createReportingRecherche();
        ReportingStore.export(reporting, true).then(
            result => {
              FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        );
      }
    },
    createReportingRecherche() {
      const reporting = new ExportReportingMensuelDto();
      reporting.date = momentToDate(this.date);
      reporting.dateFin = momentToDate(this.dateFin);
      return reporting;
    },
    isBeforeDate() {
      if (this.date && this.dateFin) {
        return this.dateFin.isBefore(this.date)
      }
      return false;
    }
  }
}

</script>

<style scoped>

</style>